import type { ContainerKind, ExternalSystemKind, RiskCategory } from "@/lib/arch-parser/types";

const CONTAINER_KIND_LABELS: Record<ContainerKind, string> = {
  service: "service",
  api: "API",
  frontend: "user interface",
  database: "database",
  worker: "background job",
  job: "scheduled job",
  queue: "task line",
  cache: "fast lookup store",
  storage: "file storage",
  "ml-model": "AI model",
  gateway: "entry point",
  other: "component",
};

const EXTERNAL_KIND_LABELS: Record<ExternalSystemKind, string> = {
  saas: "third-party service",
  infrastructure: "infrastructure",
  integration: "integration",
  "data-source": "data source",
  "ai-service": "AI service",
  "auth-provider": "identity provider",
  "payment-provider": "payment service",
  other: "external service",
};

const RISK_CATEGORY_LABELS: Record<RiskCategory, string> = {
  cost: "Cost",
  scalability: "Scale",
  security: "Security",
  compliance: "Compliance",
  "data-readiness": "Data isn't ready",
  "data-connectivity": "Data access",
  operability: "Day-to-day operations",
  "vendor-lock-in": "Stuck with one vendor",
  other: "Other",
};

export function containerKindLabel(kind: ContainerKind): string {
  return CONTAINER_KIND_LABELS[kind] ?? kind;
}

export function externalKindLabel(kind: ExternalSystemKind): string {
  return EXTERNAL_KIND_LABELS[kind] ?? kind;
}

export function riskCategoryLabel(category: RiskCategory): string {
  return RISK_CATEGORY_LABELS[category] ?? category;
}
